import { useEffect, useState } from "react";
import type { AnalyticsEvent } from "~types/app/analytics-session.types";

const GTM_ID = import.meta.env.VITE_GTM_ID;

export function addGtmScript(GTM_ID: string) {
  // Code copied from GTM console + added type annotations.
  (function (w: Window, d: Document, s: "script", l: string, i: string) {
    w[l] = w[l] || [];
    w[l].push({
      "gtm.start": new Date().getTime(),
      event: "gtm.js",
    });
    const f = d.getElementsByTagName(s)[0];
    const j = d.createElement<"script">(s);
    const dl = l != "dataLayer" ? "&l=" + l : "";
    j.async = true;
    j.src = "https://www.googletagmanager.com/gtm.js?id=" + i + dl;
    f?.parentNode?.insertBefore(j, f);
  })(window, document, "script", "dataLayer", GTM_ID);

  console.info("Google Tag Manager script added.");
  console.info("GTM_ID:", GTM_ID);
  console.info("window.dataLayer:", window.dataLayer);
}

function pushToDataLayer(data: any) {
  if (!window?.dataLayer?.push) {
    console.warn(`dataLayer not found`, data);
    return;
  }
  window.dataLayer.push(data);
  console.info(`dataLayer push`, data);
}

function dataLayerEvent({ event, data }: { event: string; data: any }) {
  pushToDataLayer({ event, ...data });
}

function gtagEvent({ event, data }: { event: string; data: any }) {
  if (!window?.gtag) {
    console.warn(`gtag event not sent because gtag is not loaded`, { event, data });
    return;
  }
  if (data?.ecommerce) {
    window.gtag("event", event, { ...data.ecommerce });
    console.info(`gtag event sent`, { event, data });
  } else {
    window.gtag("event", event, data);
    console.info(`gtag event sent`, { event, data });
  }
}

export const analytics = { event: GTM_ID ? dataLayerEvent : gtagEvent };

/** Hook to send analytics events on page load */
export function useAnalyticsEvents({
  pathname,
  pageLoadEvents,
}: {
  pathname: string | null;
  pageLoadEvents?: Array<AnalyticsEvent> | null | undefined;
}) {
  // Send only once on page load (if pathname changes, send again)
  const [trackedUrl, setTrackedUrl] = useState<string | null>(null);

  useEffect(() => {
    if (!pathname || trackedUrl !== pathname) {
      setTrackedUrl(pathname);
      if (pageLoadEvents && pageLoadEvents.length > 0) {
        pageLoadEvents.forEach((event) => {
          analytics.event(event);
        });
      }
    }
  }, [pathname, pageLoadEvents, trackedUrl]);

  return null;
}
